import apiClient from '../client';

export interface DashCoverPriceSheetMetadata {
  sheets: number[];
  trims: string[];
  priceCodes: string[];
  fabricNames: string[];
  tiers: number[];
}

export interface DashCoverPriceSheetFilters {
  fabricName?: string;
  tier?: number;
}

export interface DashCoverPriceSheetData {
  data: Record<string, number>;
  trimFabrics: Record<string, string>;
  trimTiers: Record<string, number>;
}

export const dashCoverPriceSheetService = {
  getMetadata: async (): Promise<DashCoverPriceSheetMetadata> => {
    const response: any = await apiClient.get('/dash-cover-price-sheets/metadata');
    return response.data;
  },

  getSheetData: async (sheetName: number, filters?: DashCoverPriceSheetFilters): Promise<DashCoverPriceSheetData> => {
    const params: Record<string, string> = {};
    if (filters?.fabricName) params.fabricName = filters.fabricName;
    if (filters?.tier !== undefined) params.tier = filters.tier.toString();

    const response: any = await apiClient.get(`/dash-cover-price-sheets/${sheetName}`, { params });
    return response.data;
  },

  saveSheetData: async (
    sheetName: number,
    data: Record<string, number>,
    trimFabrics: Record<string, string>,
    trimTiers: Record<string, number>
  ): Promise<void> => {
    await apiClient.post(`/dash-cover-price-sheets/${sheetName}`, { data, trimFabrics, trimTiers });
  },
};
